import { Card, styled } from "@mui/material";

export const CardOutline = styled(Card)`
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: none;
`;
